import { render, staticRenderFns } from "./AcaoMkt.vue?vue&type=template&id=5725908c"
import script from "./AcaoMkt.vue?vue&type=script&lang=js"
export * from "./AcaoMkt.vue?vue&type=script&lang=js"
import style0 from "./AcaoMkt.vue?vue&type=style&index=0&id=5725908c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports